var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5030_18907",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5030_18907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0006 64.1668C31.0145 64.1668 27.2472 63.4012 23.6986 61.8699C20.15 60.3387 17.051 58.2484 14.4017 55.5991C11.7524 52.9498 9.66211 49.8509 8.13086 46.3022C6.59961 42.7536 5.83398 38.9863 5.83398 35.0002C5.83398 30.9654 6.59961 27.1859 8.13086 23.6616C9.66211 20.1373 11.7524 17.0505 14.4017 14.4012C17.051 11.7519 20.15 9.66162 23.6986 8.13037C27.2472 6.59912 31.0145 5.8335 35.0006 5.8335C35.827 5.8335 36.5197 6.11301 37.0788 6.67204C37.6378 7.23107 37.9173 7.92377 37.9173 8.75016C37.9173 9.57655 37.6378 10.2693 37.0788 10.8283C36.5197 11.3873 35.827 11.6668 35.0006 11.6668C28.5354 11.6668 23.0302 13.9394 18.485 18.4845C13.9399 23.0297 11.6673 28.5349 11.6673 35.0002C11.6673 41.4654 13.9399 46.9706 18.485 51.5158C23.0302 56.0609 28.5354 58.3335 35.0006 58.3335C41.4659 58.3335 46.9711 56.0609 51.5163 51.5158C56.0614 46.9706 58.334 41.4654 58.334 35.0002C58.334 34.1738 58.6135 33.4811 59.1725 32.922C59.7316 32.363 60.4243 32.0835 61.2506 32.0835C62.077 32.0835 62.7697 32.363 63.3288 32.922C63.8878 33.4811 64.1673 34.1738 64.1673 35.0002C64.1673 38.9863 63.4017 42.7536 61.8704 46.3022C60.3392 49.8509 58.2489 52.9498 55.5996 55.5991C52.9503 58.2484 49.8635 60.3387 46.3392 61.8699C42.8149 63.4012 39.0354 64.1668 35.0006 64.1668Z",
    fill: "#FE6F00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressActivity);
export default __webpack_public_path__ + "static/media/progress_activity.0f4f4fb6ab16e6bf27a5d18576a257ff.svg";
export { ForwardRef as ReactComponent };